import React from "react";
import Sidebar from "./Sidebar";

/** Mevcut (klasik) sidebar shell — Tema 1 */
const SidebarTheme1 = (props) => <Sidebar {...props} shellThemeVariant="1" />;

export default SidebarTheme1;
